var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDeslikeunselected = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_864_3772",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 33,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_864_3772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16H35.1667V33.3333L25.8334 42.6667L24.1667 41C24.0112 40.8444 23.8834 40.6333 23.7834 40.3667C23.6834 40.1 23.6334 39.8444 23.6334 39.6V39.1333L25.1 33.3333H16.5C15.7889 33.3333 15.1667 33.0667 14.6334 32.5333C14.1 32 13.8334 31.3778 13.8334 30.6667V28C13.8334 27.8444 13.8556 27.6778 13.9 27.5C13.9445 27.3222 13.9889 27.1556 14.0334 27L18.0334 17.6C18.2334 17.1556 18.5667 16.7778 19.0334 16.4667C19.5 16.1556 19.9889 16 20.5 16ZM32.5 18.6667H20.5L16.5 28V30.6667H28.5L26.7 38L32.5 32.2V18.6667ZM35.1667 33.3333V30.6667H39.1667V18.6667H35.1667V16H41.8334V33.3333H35.1667Z",
    fill: "#E60115"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeslikeunselected, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deslikeunselected.404b5c69.svg";
export { ForwardRef as ReactComponent };